import { useSetAtom } from 'jotai';
import { atomWithReset, RESET } from 'jotai/utils';
import { useEffect } from 'react';

export const backgroundColorAtom = atomWithReset('bg-white');

export function useBackgroundColor(backgroundColor: string) {
    const setBackgroundColor = useSetAtom(backgroundColorAtom);
    useEffect(() => {
        setBackgroundColor(backgroundColor);
        return () => {
            setBackgroundColor(RESET);
        };
    }, [backgroundColor]);
}
